// extracted by mini-css-extract-plugin
export default {"container":"search_container__FSk0e","input":"search_input__2zMoD"};